import { createActionGroup, props } from '@ngrx/store';
import { ClientType } from '../types';
import {
  ClientActionType,
  CollaborationPackageFilter,
  CollaborationPackageParams,
  CollaborationPackageResponse,
} from '../types/collaboration-package.types';

export const CollaborationPackageActions = createActionGroup({
  source: 'CollaborationPackage',
  events: {
    Load: props<{ filter: CollaborationPackageFilter; params: CollaborationPackageParams }>(),
    'Clear State': props<{ excludeMeta?: boolean }>(),
    'Set Meta': props<{ meta: CollaborationPackageResponse['meta'] }>(),
    'Load Email For Client': props<{ clientId?: number; cloudApiKey?: string }>(),
    'Load Email For Client Succeeded': props<{ email: string | null }>(),
    'Load Email For Client Failed': props<{ error: unknown }>(),
    'Load Client': props<{ clientId: number }>(),
    'Load Client Succeeded': props<{ client: ClientType | null }>(),
    'Load Client Failed': props<{ error: unknown }>(),
    'Onboard Existing Client': props<{ clientId: number; email: string; loadRemoteVatIntervalInformation: boolean }>(),
    'Onboard Existing Client Succeeded': props<{ key: string }>(),
    'Onboard Existing Client Failed': props<{ error: unknown }>(),
    'Onboard Non Existing Client': props<{
      cloudApiKey: string;
      email: string;
      loadRemoteVatIntervalInformation: boolean;
    }>(),
    'Onboard Non Existing Client Succeeded': props<{ key: string }>(),
    'Onboard Non Existing Client Failed': props<{ error: unknown }>(),

    'Onboard With Annual Client Collaboration Package': props<{
      cloudApiKey: string;
      name: string;
      socialSecurityNumber: string;
    }>(),
    'Onboard With Annual Client Collaboration Package Succeeded': props<{ name: string }>(),
    'Onboard With Annual Client Collaboration Package Failed': props<{ error: unknown }>(),

    'Change Package On New Subscription Type': props<{
      cloudApiKey: string;
    }>(),

    'Archive Cloud Database': props<{
      cloudApiKey: string;
      years: number;
      name: string;
      clientAction: ClientActionType;
    }>(),
    'Archive Cloud Database Succeeded': props<{ cloudApiKey: string; name: string; clientAction: ClientActionType }>(),
    'Archive Cloud Database Failed': props<{ error: unknown }>(),

    'Unarchive Cloud Database': props<{
      cloudApiKey: string;
      name: string;
      socialSecurityNumber: string;
      clientAction: ClientActionType;
    }>(),
    'Unarchive Cloud Database Succeeded': props<{
      cloudApiKey: string;
      name: string;
      clientAction: ClientActionType;
    }>(),
    'Unarchive Cloud Database Failed': props<{ error: unknown }>(),

    'Delete Cloud Database': props<{
      cloudApiKey: string;
      name: string;
      clientAction: ClientActionType;
    }>(),
    'Delete Cloud Database Succeeded': props<{ cloudApiKey: string; name: string; clientAction: ClientActionType }>(),
    'Delete Cloud Database Failed': props<{ error: unknown }>(),
    'Showing Missing Collaboration Packages Dialog': props<{ visible: boolean }>(),
  },
});
